module.exports = __webpack_public_path__ + "static/media/calendar.3e734ef0.svg";